import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Checkbox } from '@/js/libs/ui/src/V2';
import { Label, OptionWrapper } from './styled';
const _OptionCheckbox = ({ option, checked, onClick, formatOptionLabel }) => {
    const label = React.useMemo(() => (formatOptionLabel ? formatOptionLabel(option) : option.label), [formatOptionLabel, option]);
    return (_jsxs(OptionWrapper, { onClick: onClick, "data-testid": 'option-checkbox', children: [_jsx(Checkbox, { checked: checked, onChange: onClick }), _jsx(Label, { "data-testid": 'option-label', children: label })] }));
};
export const OptionCheckbox = React.memo(_OptionCheckbox);
